import { Sheet, SheetContent, SheetTitle, SheetDescription, SheetTrigger } from "../ui/sheet";
import { Button } from "../ui/button";
import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Separator } from "../ui/separator";
import { UserProfile } from "../blocks/MobileNavigation/UserProfile";
import { Fragment } from "react";
import { SidebarNavItem, SidebarNavItemProps } from "../core/SidebarNavItem";

export interface MobileNavigationProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  navigation: Array<SidebarNavItemProps>;
}

export function MobileNavigation({
  isOpen,
  setIsOpen,
  navigation,
}: MobileNavigationProps) {
  const { t } = useTranslation();

  const handleClose = () => setIsOpen(false);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon">
          <Menu className="h-5 w-5" />
          <span className="sr-only">{t("accessibility.openMenu")}</span>
        </Button>
      </SheetTrigger>

      <SheetContent
        side="left"
        className="w-[240px] sm:w-[280px] bg-dark-foreground text-dark"
      >
        {/* Hidden title and description in the sheet to avoid screen readers warning by radix-ui */}
        <SheetTitle className="hidden" />
        <SheetDescription className="hidden">
          {t("accessibility.mobileNavigationDescription")}
        </SheetDescription>

        <nav className="flex flex-col gap-4 p-4">
          <img src="/images/logo_primary.svg" alt="logo" className="h-4 w-20" />

          <Separator />

          <UserProfile />

          <Separator />

          <div className="flex flex-col gap-2 bg-muted-foreground/5 rounded-lg py-2">
            {navigation.map((item, index) => (
              <Fragment key={item.name}>
                <SidebarNavItem
                  name={item.name}
                  href={item.href}
                  onClick={item.onClick}
                  onClose={handleClose}
                  role={item.role}
                  disabled={item.disabled}
                />

                {index !== navigation.length - 1 && (
                  <Separator className="w-full bg-muted-foreground/10" />
                )}
              </Fragment>
            ))}
          </div>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
